import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import NativeSelect from '@material-ui/core/NativeSelect';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Table from '../common/table';
import DashboardWeployeesListTableRow from './DashboardWeployeesListTableRow';

const SORT_STATES = ['Name', 'Start date', 'End date'];
const SORT_COLUMNS = ['weployeeName', 'startTime', 'finishTime'];

export const StyledTableCell = styled(Table.Cell)`
  &:nth-child(1) {
    font-size: 16px;
  }

  &:nth-child(3) {
    white-space: nowrap;
  }
`;

const StyledInputLabel = styled(InputLabel)`
  color: ${props => props.theme.colors.text.primary};

  &.Mui-focused {
    color: ${props => props.theme.colors.text.primary};
  }
`;

const StyledNativeSelect = styled(NativeSelect)`
  & .MuiNativeSelect-select:focus {
    background: none;
  }

  &.MuiInput-underline:after {
    border-bottom-color: ${props => props.theme.colors.text.primary};
  }
`;

const DashboardWeployeesList = ({ data, onExtendButton }) => {
  const [sortState, setSortState] = useState(0);
  const sortedPositions = [...data];

  React.useMemo(() => {
    sortedPositions.sort((a, b) => {
      if (a[SORT_COLUMNS[sortState]] < b[SORT_COLUMNS[sortState]]) {
        return -1;
      }
      if (a[SORT_COLUMNS[sortState]] > b[SORT_COLUMNS[sortState]]) {
        return 1;
      }
      return 0;
    });
  }, [sortState, sortedPositions]);

  const handleChange = (event) => {
    const { value } = event.target;
    setSortState(value);
  };

  if (data.length === 0) {
    return 'There are no active positions';
  }

  return (
    <>
      <FormControl>
        <StyledInputLabel>Sort by</StyledInputLabel>
        <StyledNativeSelect
          value={sortState}
          onChange={handleChange}
          input={<Input name="sort-by" id="sort-by" />}
        >
          {
            SORT_STATES.map(state => (
              <option key={state} value={SORT_STATES.indexOf(state)}>{state}</option>
            ))
          }
        </StyledNativeSelect>
      </FormControl>
      <Table>
        <Table.Body>
          <Table.Row>
            <StyledTableCell />
            <StyledTableCell><strong>Name</strong></StyledTableCell>
            <StyledTableCell><strong>Start date</strong></StyledTableCell>
            <StyledTableCell><strong>Finish date</strong></StyledTableCell>
            <StyledTableCell><strong>Action</strong></StyledTableCell>
          </Table.Row>
          { sortedPositions.map(position => <DashboardWeployeesListTableRow key={position.id} position={position} onExtendButton={onExtendButton} />) }
        </Table.Body>
      </Table>
    </>
  );
};

DashboardWeployeesList.propTypes = {
  data: PropTypes.array.isRequired,
  onExtendButton: PropTypes.func,
};

DashboardWeployeesList.defaultProps = {
  onExtendButton: () => {},
};

export default DashboardWeployeesList;
